import React from 'react';
import { Col } from 'react-bootstrap';
import cx from 'classnames';

import styles from './styles.module.scss';

interface PlaceholderCellProps {
    col: number;
    type: string;
}

const PlaceholderCell: React.FC<PlaceholderCellProps> = ({ col, type }) => {
    const renderSkeleton = () => {
        switch (type) {
            case 'name':
            case 'owner':
            case 'lastActivity':
                return (
                    <div className={cx(styles.placeholder)}>
                        <span className={cx(styles.line, styles.lineLg, styles.block)} />
                    </div>
                );
            case 'amount':
                return (
                    <div className={cx(styles.placeholder)}>
                        <span className={cx(styles.line, styles.lineMd, styles.block)} />
                    </div>
                );
            case 'prediction':
                return (
                    <div className={cx(styles.placeholder)}>
                        <span className={cx(styles.line, styles.lineSm, styles.block)} />
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Col md={col} className={styles.placeholderContainer}>
            {renderSkeleton()}
        </Col>
    );
};

export default PlaceholderCell;
